import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, TextField } from '@mui/material'
import UnitAdornment from '@component/UnitAdornment'
import AreaUnit from '@component/AreaUnit'
import { useColumn } from './context'

function ColumnResult () {
  const { t } = useTranslation()
  const { form, result } = useColumn()

  const hidden = !form.formState.isSubmitSuccessful

  const isHidden = (
    hidden
    || result === null
    || result === undefined
  )

  if (isHidden) return <></>

  const InputProps = {
    endAdornment: <UnitAdornment unit={<AreaUnit />} />,
  }

  const srcResult = `${(+result.criterionSize).toFixed(0)} x ${(+result.calculatedSize).toFixed(0)}`
  const rcResult = `${(+result.criterionSize).toFixed(0)} x ${(+result.calculatedSizeForLateral).toFixed(0)}`

  return (
    <Card>
      <CardHeader title={t('COMPOUND.RESULT', { label: 'GLOSSARY.COLUMN' })} />
      <CardContent className="flex flex-col gap-16">
        <TextField
          label={t('GLOSSARY.MIN_REQUIRED_AREA')}
          disabled
          InputProps={InputProps}
          type="text"
          value={srcResult}
        />
        <TextField
          label={t('GLOSSARY.MIN_REQUIRED_CIRCLE_DIAMETER')}
          disabled
          InputProps={{
            endAdornment: <UnitAdornment unit="mm" />,
          }}
          value={result.needDiameterForCircle.toFixed(0)}
        />
        <TextField
          label={t('GLOSSARY.MIN_REQUIRED_LATERAL_AREA')}
          InputProps={InputProps}
          disabled
          type="text"
          value={rcResult}
        />
      </CardContent>
    </Card>
  )
}

export default ColumnResult
